export const NYM_STATUSES = {
  PENDINGKYC: 'PENDINGKYC',
  PENDINGKYB: 'PENDINGKYB',
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  TERMINATED: 'TERMINATED',
  PENDINGIDVERIFICATION: 'PENDINGIDVERIFICATION',
  TRY_ESHE_RAZOK: 'TRY_ESHE_RAZOK',
};
